export default {
  label: {
    blockchain: 'Blockchain',
    wallet: 'Wallet url',
    agentNo: 'Agent code',
    usdtAmount: 'USDT Amount',
    usdtFee: 'USDT Fee',
    modify: 'Update account info',
    delete: 'Remove this account',
    withdrawCount: 'Withdraw Count',
    submitAmount: 'Submit amount USDT',
    submitVndAmount: 'Submit amount VND',
    successAmount: 'Success amount',
    exchangeRate: 'System exchange rate',
    copy: 'copy'
  },
  rules: {
    blockchain: 'Blockchain can bot be empty.',
    wallet: 'Wallet url can bot be empty.',
    type: 'The withdrawal amount must be digital.',
    min: 'The withdrawal amount must greater than 100',
    max: 'The withdrawal amount cannot be greater than the balance.'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/usdt.js